import {css} from '@emotion/react'
import InputColor from '@/components/Form/InputColor.jsx'

import {
    PropertiesController,
    usePropertiesController,
} from './PropertiesController.jsx'

const cssInput = css({
    width: '100%',
})

export default function PropertiesControllerColor({
    className,
    style,
    disabled,
    hidden,
    label,
    labelSuffix,
    prop,
    required,
    readOnly,
    value,
    ...props
}) {
    const p = usePropertiesController({
        disabled,
        hidden,
        label,
        prop,
        readOnly,
        required,
        value,
    })

    return (
        <PropertiesController
            className={className}
            style={style}
            error={p.error}
            hidden={p.hidden}
            label={p.label}
            labelSuffix={labelSuffix}
            required={p.required}
        >
            <InputColor
                css={cssInput}
                disabled={p.disabled}
                readOnly={p.readOnly}
                value={p.value}
                onChange={p.onChange}
                {...props}
            />
        </PropertiesController>
    )
}
